<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL of PHARMACY</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Pharmacy</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Under Graduate</th>
                            <th class="time">Diploma</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">Bachelor of Pharmacy</td>
                            <td class="time">Diploma in Pharmacy</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <h5 class="text-decoration-underline text-center">Pharmacy</h5>

        <div class="row">
            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Pharmacy </b>
                    – The Bachelor of Pharmacy program at ARNI School of Pharmacy prepares students by teaching them the
                    essentials and important facts about medications, drugs, and how they are managed and used.
                    Pharmaceutics, Inorganic Medicinal Chemistry, Biochemistry, and Human Anatomy are among the
                    disciplines included in a B.Pharm. There are eight semesters in this four-year study.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">B.Pharmacy </b> : 1st Semester</p>
                <ul>
                    <li> Human Anatomy & Physiology</li>
                    <li> Communication skills (Theory)</li>
                    <li> Pharmaceutics I (Theory)</li>
                    <li> Pharmaceutical Analysis I (Theory)</li>
                    <li> Pharmaceutical Inorganic Chemistry (Theory)</li>
                    <li> Remedial Biology/ Mathematics (Theory)</li>
                    <li> Human Anatomy and Physiology – Practical</li>
                    <li> Pharmaceutical Analysis I – Practical</li>
                    <li> Pharmaceutics I – Practical</li>
                    <li> Pharmaceutical Inorganic Chemistry – Practical</li>
                    <li> Chemistry – Practical Communication skills- Practical</li>
                    <li> Remedial Biology – Practical</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">B.Pharmacy</b> : 2nd Semester</p>
                <ul>
                    <li> Human Anatomy and Physiology II (Theory)</li>
                    <li> Environmental Sciences (Theory)</li>
                    <li> Pathophysiology (Theory)</li>
                    <li> Pharmaceutical Organic Chemistry I (Theory)</li>
                    <li> Biochemistry (Theory)</li>
                    <li> Computer Applications in Pharmacy (Theory)</li>
                    <li> Biochemistry – Practical</li>
                    <li> Human Anatomy and Physiology II –Practical</li>
                    <li> Pharmaceutical Organic Chemistry I– Practical</li>
                    <li> Computer Applications in Pharmacy - Practical</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">B.Pharmacy</b> : 3rd Semester</p>
                <ul>
                    <li> Pharmaceutical Microbiology (Theory)</li>
                    <li> Physical Pharmaceutics I (Theory)</li>
                    <li> Pharmaceutical Engineering (Theory)</li>
                    <li> Pharmaceutical Organic Chemistry II (Theory)</li>
                    <li> Pharmaceutical Microbiology – Practical</li>
                    <li> Physical Pharmaceutics I - Practical</li>
                    <li> Pharmaceutical Engineering – Practical</li>
                    <li> Pharmaceutical Organic Chemistry II – Practical</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">B.Pharmacy</b> : 4th Semester</p>
                <ul>
                    <li> Medicinal Chemistry I (Theory)</li>
                    <li> Pharmacology I (Theory)</li>
                    <li> Physical Pharmaceutics II (Theory)</li>
                    <li> Pharmaceutical Organic Chemistry III (Theory)</li>
                    <li> Pharmacognosy I (Theory)</li>
                    <li> Medicinal Chemistry I – Practical</li>
                    <li> Pharmacology I – Practical</li>
                    <li> Physical Pharmaceutics II –Practical</li>
                    <li> Pharmacognosy I – Practical</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">B.Pharmacy</b> : 5th Semester</p>
                <ul>
                    <li> Industrial Pharmacy I (Theory)</li>
                    <li> Medicinal Chemistry II (Theory)</li>
                    <li> Pharmacology II (Theory)</li>
                    <li> Pharmacognosy and Phytochemistry II (Theory)</li>
                    <li> Pharmaceutical Jurisprudence (Theory)</li>
                    <li> Industrial Pharmacy I– Practical</li>
                    <li> Pharmacology II – Practical</li>
                    <li> Pharmacognosy and Phytochemistry II – Practical</li>

                </ul>
            </div>


            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">B.Pharmacy</b> : 6th Semester</p>
                <ul>
                    <li> Biopharmaceutics and Pharmacokinetics (Theory)</li>
                    <li> Herbal Drug Technology (Theory)</li>
                    <li> Quality Assurance (Theory)</li>
                    <li> Medicinal Chemistry III (Theory)</li>
                    <li> Pharmacology III (Theory)</li>
                    <li> Pharmaceutical Biotechnology (Theory)</li>
                    <li> Medicinal Chemistry III –Practical</li>
                    <li> Pharmacology III – Practical</li>
                    <li> Herbal Drug Technology –Practical</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">B.Pharmacy</b> : 7th Semester</p>
                <ul>
                    <li> Industrial Pharmacy (Theory)</li>
                    <li> Instrumental Methods of Analysis (Theory)</li>
                    <li> Novel Drug Delivery System (Theory)</li>
                    <li> Pharmacy Practice (Theory)</li>
                    <li> Instrumental Methods of Analysis– Practical</li>
                    <li> Practice School</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">B.Pharmacy</b> : 8th Semester</p>
                <ul>
                    <li> Advanced Instrumentation Techniques (Theory)</li>
                    <li> Biostatistics and Research Methodology (Theory)</li>
                    <li> Cosmetic Science – Theory</li>
                    <li> Computer-Aided Drug Design –Theory</li>
                    <li> Cell and Molecular Biology –Theory</li>
                    <li> Experimental Pharmacology –Theory</li>
                    <li> Quality Control and Standardization of Herbals – Theory</li>
                    <li> Pharma Marketing Management –Theory</li>
                    <li> Pharmaceutical Regulatory Science – Theory</li>
                    <li> Pharmacovigilance – Theory</li>
                    <li> Social and Preventive Pharmacy– Theory</li>
                    <li> Dietary Supplements and Nutraceuticals</li>
                    <li> Project Work</li>
                </ul>
            </div>

            <hr class="border-dashed" style="border:2px;"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Diploma in Pharmacy </b> –
                    The two-year diploma program in pharmacy offered by ARNI School of Pharmacy covers both the science
                    and the art of making and distributing medications. Students learn the fundamentals of pharmacy
                    education, such as how chemistry is used in the pharmaceutical industry and the principles of
                    toxicology, pharmacology, and biochemistry. The course lasts for two years, broken up into four
                    semesters.

                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">D.Pharma </b> : 1st Semester</p>
                <ul>
                    <li> Biochemistry and Clinical Pathology</li>
                    <li> Human Anatomy and Physiology – I</li>
                    <li> Health Education and Community Pharmacy- I</li>
                    <li> Pharmacognosy – I</li>
                    <li> Pharmaceutical Chemistry-I Lab</li>
                    <li> Pharmacognosy Lab</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">D.Pharma </b> : 2nd Semester</p>
                <ul>
                    <li> Drug Store and Business Management</li>
                    <li> Hospital and Clinical Pharmacy</li>
                    <li> Pharmacology & Toxicology</li>
                    <li> Pharmaceutical Chemistry- I</li>
                    <li> Pharmaceutical Chemistry-II Lab</li>
                    <li> Pharmaceutics Lab</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">D.Pharma </b> : 3rd Semester</p>
                <ul>
                    <li> Antibiotics</li>
                    <li> Human Anatomy and Physiology – II</li>
                    <li> Health Education and Community Pharmacy</li>
                    <li> Pharmacognosy- II</li>
                    <li> Biochemistry and Clinical Pathology Lab</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">D.Pharma </b> : 4th Semester</p>
                <ul>
                    <li> Health Education and Community Pharmacy- II</li>
                    <li> Pharmaceutical Chemistry-II</li>
                    <li> Pharmaceutics</li>
                    <li> Pharmaceutical Jurisprudence</li>
                    <li> Hospital and Clinical Pharmacy Lab</li>
                </ul>
            </div>
        </div>

    </div>
</section>
